<template>
    <div class="certificates-results">
        <div class="certificates-results__container">
            <p class="certificates-results__count" v-html="resultCount"></p>
            <z-card
                :key="index"
                target="_black"
                v-for="(item, index) in data"
                :link="item.title && item.title.url"
            >
                <template
                    v-slot:title
                    v-if="item.title"
                >
                    {{ item.title.name }}
                </template>
                <template v-slot:content>
                    <div class="certificates-results__detail">
                        <div class="certificates-results__detail-header">
                            <div class="certificates-results__detail-item" v-if="item.number">
                                <span>{{ text.number }}</span>
                                <span class="evraz-red-text" v-html="item.number"></span>
                            </div>
                            <div class="certificates-results__detail-item" v-if="item.dateBegin">
                                <span>{{ text.dateBegin }}</span>
                                <span>{{ item.dateBegin | momentFilter('DD MMMM YYYY') }}</span>
                            </div>
                            <div class="certificates-results__detail-item" v-if="item.dateEnd">
                                <span>{{ text.dateEnd }}</span>
                                <span>{{ item.dateEnd | momentFilter('DD MMMM YYYY') }}</span>
                            </div>
                        </div>
                        <div class="certificates-results__detail-footer">
                            <div class="certificates-results__detail-item" v-if="item.type">
                                <span>{{ text.type }}</span>
                                <span>{{ item.type }}</span>
                            </div>
                            <div class="certificates-results__detail-item" v-if="item.agency">
                                <span>{{ text.agency }}</span>
                                <span v-html="item.agency"></span>
                            </div>
                        </div>
                    </div>
                </template>
            </z-card>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'results',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        nav: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            text: {
                number: localize({
                    ru: 'Номер сертификата:',
                    en: 'Certificate number:'
                }),
                dateBegin: localize({
                    ru: 'Дата выдачи:',
                    en: 'Date of issue:'
                }),
                dateEnd: localize({
                    ru: 'Срок действия:',
                    en: 'Date of expiry:'
                }),
                type: localize({
                    ru: 'Тип сертификации:',
                    en: 'Certification type:'
                }),
                agency: localize({
                    ru: 'Орган по сертификации:',
                    en: 'Certification body:'
                })
            }
        }
    },
    computed: {
        resultCount () {
            if (this.nav.count === null) return ''
            if (this.nav.count === 0) return ''

            const start = localize({
                ru: ['найден', 'найдено', 'найдено'],
                en: ['found', 'found', 'found']
            })

            const end = localize({
                ru: ['сертификат', 'сертификата', 'сертификатов'],
                en: ['certificate', 'certificates', 'certificates']
            })

            let stringStart = this.declOfNum(this.nav.count, start)
            let stringEnd = this.declOfNum(this.nav.count, end)

            return `${stringStart} ${this.nav.count} ${stringEnd}`
        }
    },
    methods: {
        declOfNum (number, titles) {
            let cases = [2, 0, 1, 1, 1, 2]

            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
        }
    }
}
</script>

<style lang="scss">
.certificates-results {

    &__container {
        margin-top: $token-spacers-xxxl;
        position: relative;
    }

    &__count {
        margin-bottom: $token-spacers-m;
        color: $token-colors-black-60;
    }

    &__detail {
        $detail: &;

        &-header,
        &-footer {
            display: flex;
            flex-wrap: wrap;
        }

        &-header {
            margin-left: -$token-spacers-s;
            margin-right: -$token-spacers-s;
            margin-bottom: 44px;

            #{$detail}-item {
                padding: 0 $token-spacers-s;
            }
        }

        &-footer {
            margin: -$token-spacers-xs -$token-spacers-m;

            #{$detail}-item {
                padding: $token-spacers-xs $token-spacers-m;

                span {
                    display: block;
                    font-size: 14px;
                }
            }
        }

        &-item {
            span {
                font-size: 16px;
                line-height: 1.3;
                color: $token-colors-black-40;

                + span {
                    color: $token-colors-black;
                }
            }
        }
    }

    .z-card {

        + .z-card {
            margin-top: $token-spacers-m;
        }

        &__title {
            margin-bottom: $token-spacers-m;
        }
    }
}
</style>
